import type {CaseReturnReason} from "@indebted/api"

const phrasingByReasonID: Record<string, string> = {
	DEADLINE_PASSED: "deadline passed",
	CUSTOMER_REPLIED: "customer replied",
	AGENT_RETURNED: "agent returned it",
}

function phraseReturnReason(reason: CaseReturnReason): string {
	return phrasingByReasonID[reason.ID] ?? reason.Label
}

export {phraseReturnReason}
